import { Avatar } from "antd";
import { useChatContext } from "stream-chat-react";
import styled from "styled-components";

import UserBadge from "../UserBadge/UserBadge";
import HashIcon from "./HashIcon";

const CountTile = styled(Avatar)`
  background-color: #8c8c8c;
  color: #fff;
  font-weight: 600;
  font-size: 20px;
  flex-shrink: 0;
`;

function formatNameList(names) {
  if (names.length === 0) return "";
  if (names.length === 1) return names[0];
  if (names.length === 2) return `${names[0]} and ${names[1]}`;
  return `${names.slice(0, -1).join(", ")}, and ${names[names.length - 1]}`;
}

export default function EmptyChannel() {
  const { channel, client } = useChatContext();

  const members = Object.values(channel?.state?.members || {}).filter(
    ({ user }) => user?.id !== client.userID,
  );

  const isTeam = channel?.type === "team";
  const names = members.map((m) => m.user?.name || m.user?.id).filter(Boolean);

  const renderIndicator = () => {
    if (isTeam) return <HashIcon />;
    if (members.length === 0) return <UserBadge name="?" size={56} />;
    if (members.length === 1) {
      const m = members[0];
      return (
        <UserBadge
          name={m.user?.name || m.user?.id}
          image={m.user?.image}
          userId={m.user?.id}
          size={56}
        />
      );
    }
    return (
      <CountTile shape="square" size={56}>
        {members.length}
      </CountTile>
    );
  };

  const renderHeadline = () => {
    if (isTeam) return `#${channel?.data?.name || channel?.data?.id || "channel"}`;
    if (members.length === 0) return "New conversation";
    if (members.length === 1) return `Chat with ${names[0]}`;
    return `New conversation with ${members.length} people`;
  };

  return (
    <div className="channel-empty__container">
      <div className="channel-empty__indicator">{renderIndicator()}</div>
      <p className="channel-empty__headline">{renderHeadline()}</p>
      {!isTeam && members.length > 1 && (
        <p className="channel-empty__names">{formatNameList(names)}</p>
      )}
      <p className="channel-empty__secondary-description">
        Send messages, attachments, links, emojis, and more.
      </p>
    </div>
  );
}
